<template>
  <div
    class="v-radio-group"
    role="radiogroup"
    :class="classes"
    :style="styles"
  >
    <slot/>
  </div>
</template>

<script>

export default {
  name: 'VRadioGroup',
  emits: ['input', 'change'],
  data() {
    return {
      localValue: this.value
    }
  },
  props: {
    column: {
      type: Boolean,
      default: true,
    },
    height: {
      type: Number,
    },
    name: {
      type: String,
      required: true,
    },
    row: Boolean,
    value: null,
  },
  computed: {
    classes() {
      return {
        'v-radio-group--column': !this.row,
        'v-radio-group--row': this.row,
      };
    },
    styles() {
      return {
        height: !!this.height && typeof this.height === 'number' ? `${this.height}px` : '',
      };
    },
  },
  mounted() {
    this.setRadios();
  },
  methods: {
    setRadios() {
      const radios = this.$slots.default;

      if (!!radios) {
        radios.forEach(radio => {
          radio.elm.children[0].setAttribute('name', this.name);
        })
      }
    }
  },
  watch: {
    localValue(value) {
      this.$emit('input', value)
      this.$emit('change', value)
    },
    value(value) {
      this.localValue = value
    }
  },
};
</script>

<style lang="scss">
@import "VRadio";
</style>
